const educationprograms = {
	title: "Utdanningsprogram",
	new_educationprogram: "Nytt utdanningsprogram",
	edit_educationprogram: "Utdanningsprogram: {name}",
	view_ceducationprogram: "Vis utdanningsprogram: {name}",
	list_title: "Utdanningsprogrammer",
	list_subtitle: "Håndter utdanningsprogrammer",
	create_title: "Opprett nytt utdanningsprogram",
	update_title: "Endre utdanningsprogram",
	id: "ID",
	name: "Navn",
	code: "Kode",
	date_valid: "Gyldig fra",
	status: "Status",
	created_by: "Opprettet av",
};
export default educationprograms;